import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import UplifterSvg from '../svgs/uplifter'
import styles from '../component-styles/forgot-password.module.scss'
import Message from './login-message'

export default function Result(): React.ReactElement {
  const { success } = useSelector(
    (state: any): any => state.support.resetPassword,
  )

  if (success) {
    return (
      <div>
        <UplifterSvg link className={styles.svg} />
        <h2>Your new password has been set</h2>
        <Link className={styles.link} to="/">
          Login
        </Link>
      </div>
    )
  }

  return (
    <div>
      <UplifterSvg link className={styles.svg} />
      <h2>Your password has not been updated.</h2>
      <div className={styles.divider} />
      <Message
        message={`Please try [resetting your password](/forgot-password) again.  
If you are still experiencing issues, please contact us by emailing [support@uplifter.ai](mailto:support@uplifter.ai).`}
      />
    </div>
  )
}
